import { render, staticRenderFns } from "./BargainRecord.vue?vue&type=template&id=ec2d3876&"
import script from "./BargainRecord.vue?vue&type=script&lang=js&"
export * from "./BargainRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports